import { Portal, useSlotRecipe } from '@chakra-ui/react';
import { DraggableBox, MotionBox } from '@components/ui/draggable/DraggableBox';
import { DraggablePanelRootProps } from '@components/ui/draggable/DraggablePanel';
import { forwardRef } from 'react';

export const Root = forwardRef<typeof MotionBox, DraggablePanelRootProps>(
  ({ constraintsRef, children, offsetX = 0, offsetY = 0, ...rest }, ref) => {
    const { root } = useSlotRecipe({ key: 'draggablePanel' })();

    return (
      <Portal container={constraintsRef}>
        <DraggableBox
          ref={ref}
          {...rest}
          {...root}
          top={offsetY}
          left={offsetX}
          {...(constraintsRef ? { constraintsRef } : {})}
        >
          {children}
        </DraggableBox>
      </Portal>
    );
  },
);
